export enum ProductionTypes {
  isPolice = 0,
  isMining = 1,
  isIlaria = 2,
  isPatroleyes = 3,
  isBeta = 4,
  isIndustrialCam = 5,
}
